import { render } from "./ProductHeader.vue?vue&type=template&id=ebd34b70&scoped=true&ts=true"
import script from "./ProductHeader.vue?vue&type=script&lang=ts"
export * from "./ProductHeader.vue?vue&type=script&lang=ts"

import "./ProductHeader.vue?vue&type=style&index=0&id=ebd34b70&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd34b70"]])

export default __exports__